import { useMutation } from '@tanstack/react-query';
import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';
import { FileItem } from './detectRepository';

export interface ProcessFilesBatchBody {
  repoUrl: string;
  branchName: string;
  files: FileItem[];
  reviewers: string[];
  batchNumber: number;
  totalBatches: number;
  pipeline_name: string;
  azure_project: string;
  repoId: string;
  branchId: string;
  scanId: string | null;
  isFrontend: boolean;
}

export interface AstAnalysis {
  totalFiles: number;
  totalLines: number;
  totalMethods: number;
  totalFunctions: number;
  totalClasses: number;
  totalNonExecutableLines: number;
  totalExecutableLines: number;
  totalBranches: number;
  totalLoops: number;
  fileDetails?: unknown[];
}

export interface ProcessFilesSummary {
  filesProcessed: number;
  totalLinesOfCode: number;
  totalMethods: number;
  totalFunctions: number;
  totalClasses: number;
  batchesProcessed: number;
}

export interface ProcessFilesResponseData {
  astAnalysis: AstAnalysis;
  summary: ProcessFilesSummary;
  scanId: string;
}

export interface ProcessFilesResponse {
  data: ProcessFilesResponseData;
}

export const postProcessFilesBatch = (
  provider: ScmProviderId,
  body: ProcessFilesBatchBody,
  patToken: string,
): Promise<ProcessFilesResponse> => {
  return scmPost<ProcessFilesResponse>(
    provider,
    '/api/scm/process-files',
    patToken,
    body,
  );
};

export const useProcessFilesBatch = (
  provider: ScmProviderId,
  patToken: string,
) => {
  return useMutation({
    mutationFn: (body: ProcessFilesBatchBody) =>
      postProcessFilesBatch(provider, body, patToken),
  });
};
